/**
 * textSanitizer.ts
 * Utilitário abrangente e completo para correção de erros de codificação (Mojibake / UTF-8 / ISO-8859-1 / Windows-1252)
 * e reparo inteligente de caracteres corrompidos "??", "???", "?" em todo o sistema.
 */

// Mapeamento direto de termos frequentes em transporte, logística, obras, construção civil, financeiro e endereços
const EXACT_REPLACEMENTS: [RegExp, string][] = [
  // 1. Termos de Carga, Material e Obras (Construção Civil / Logística)
  [/\bcer[?]{1,6}mica\b/gi, 'cerâmica'],
  [/\bcer[?]{1,6}micas\b/gi, 'cerâmicas'],
  [/\bcer[?]{1,6}mico\b/gi, 'cerâmico'],
  [/\bcer[?]{1,6}micos\b/gi, 'cerâmicos'],
  [/\bservi[?]{1,6}o\b/gi, 'serviço'],
  [/\bservi[?]{1,6}os\b/gi, 'serviços'],
  [/\bpe[?]{1,6}a\b/gi, 'peça'],
  [/\bpe[?]{1,6}as\b/gi, 'peças'],
  [/\ba[?]{1,6}o\b/gi, 'aço'],
  [/\ba[?]{1,6}os\b/gi, 'aços'],
  [/\bbra[?]{1,6}o\b/gi, 'braço'],
  [/\bbra[?]{1,6}os\b/gi, 'braços'],
  [/\bca[?]{1,6}amba\b/gi, 'caçamba'],
  [/\bca[?]{1,6}ambas\b/gi, 'caçambas'],
  [/\bcaminh[?]{1,6}o\b/gi, 'caminhão'],
  [/\bcaminh[?]{1,6}es\b/gi, 'caminhões'],
  [/\bgalp[?]{1,6}o\b/gi, 'galpão'],
  [/\bgalp[?]{1,6}es\b/gi, 'galpões'],
  [/\bport[?]{1,6}o\b/gi, 'portão'],
  [/\bport[?]{1,6}es\b/gi, 'portões'],
  [/\bbalc[?]{1,6}o\b/gi, 'balcão'],
  [/\bbalc[?]{1,6}es\b/gi, 'balcões'],
  [/\bconstru[?]{1,6}o\b/gi, 'construção'],
  [/\bconstru[?]{1,6}es\b/gi, 'construções'],
  [/\bedifica[?]{1,6}o\b/gi, 'edificação'],
  [/\bedifica[?]{1,6}es\b/gi, 'edificações'],
  [/\bfunda[?]{1,6}o\b/gi, 'fundação'],
  [/\bfunda[?]{1,6}es\b/gi, 'fundações'],
  [/\binstala[?]{1,6}o\b/gi, 'instalação'],
  [/\binstala[?]{1,6}es\b/gi, 'instalações'],
  [/\btubula[?]{1,6}o\b/gi, 'tubulação'],
  [/\btubula[?]{1,6}es\b/gi, 'tubulações'],
  [/\bqu[?]{1,6}mico\b/gi, 'químico'],
  [/\bqu[?]{1,6}mica\b/gi, 'química'],
  [/\bqu[?]{1,6}micos\b/gi, 'químicos'],
  [/\bqu[?]{1,6}micas\b/gi, 'químicas'],
  [/\bel[?]{1,6}trico\b/gi, 'elétrico'],
  [/\bel[?]{1,6}trica\b/gi, 'elétrica'],
  [/\bel[?]{1,6}tricos\b/gi, 'elétricos'],
  [/\bel[?]{1,6}tricas\b/gi, 'elétricas'],
  [/\bmec[?]{1,6}nico\b/gi, 'mecânico'],
  [/\bmec[?]{1,6}nica\b/gi, 'mecânica'],
  [/\bmec[?]{1,6}nicos\b/gi, 'mecânicos'],
  [/\bmec[?]{1,6}nicas\b/gi, 'mecânicas'],
  [/\bhidr[?]{1,6}ulico\b/gi, 'hidráulico'],
  [/\bhidr[?]{1,6}ulica\b/gi, 'hidráulica'],
  [/\bhidr[?]{1,6}ulicos\b/gi, 'hidráulicos'],
  [/\bhidr[?]{1,6}ulicas\b/gi, 'hidráulicas'],
  [/\bmet[?]{1,6}lico\b/gi, 'metálico'],
  [/\bmet[?]{1,6}lica\b/gi, 'metálica'],
  [/\bmet[?]{1,6}licos\b/gi, 'metálicos'],
  [/\bmet[?]{1,6}licas\b/gi, 'metálicas'],
  [/\bpl[?]{1,6}stico\b/gi, 'plástico'],
  [/\bpl[?]{1,6}stica\b/gi, 'plástica'],
  [/\bpl[?]{1,6}sticos\b/gi, 'plásticos'],
  [/\bpl[?]{1,6}sticas\b/gi, 'plásticas'],
  [/\bautom[?]{1,6}tico\b/gi, 'automático'],
  [/\bautom[?]{1,6}tica\b/gi, 'automática'],
  [/\bautom[?]{1,6}ticos\b/gi, 'automáticos'],
  [/\bautom[?]{1,6}ticas\b/gi, 'automáticas'],
  [/\blog[?]{1,6}stica\b/gi, 'logística'],
  [/\blog[?]{1,6}stico\b/gi, 'logístico'],

  // 2. Termos de Endereço, Cidades, Bairros e Localização
  [/\blim[?]{1,6}o\b/gi, 'limão'],
  [/\bnort[?]{1,6} lim[?]{1,6}o\b/gi, 'nort limão'],
  [/\bnorte lim[?]{1,6}o\b/gi, 'norte limão'],
  [/\bobra nort lim[?]{1,6}o\b/gi, 'obra nort limão'],
  [/\bendere[?]{1,6}o\b/gi, 'endereço'],
  [/\bendere[?]{1,6}os\b/gi, 'endereços'],
  [/\bpra[?]{1,6}a\b/gi, 'praça'],
  [/\bpra[?]{1,6}as\b/gi, 'praças'],
  [/\besta[?]{1,6}o\b/gi, 'estação'],
  [/\besta[?]{1,6}es\b/gi, 'estações'],
  [/\bregi[?]{1,6}o\b/gi, 'região'],
  [/\bregi[?]{1,6}es\b/gi, 'regiões'],
  [/\bespa[?]{1,6}o\b/gi, 'espaço'],
  [/\bespa[?]{1,6}os\b/gi, 'espaços'],
  [/\bch[?]{1,6}cara\b/gi, 'chácara'],
  [/\bch[?]{1,6}caras\b/gi, 'chácaras'],
  [/\bs[?]{1,6}o paulo\b/gi, 'são paulo'],
  [/\bs[?]{1,6}o\b/gi, 'são'],
  [/\bjo[?]{1,6}o\b/gi, 'joão'],
  [/\bmaranh[?]{1,6}o\b/gi, 'maranhão'],
  [/\bbras[?]{1,6}lia\b/gi, 'brasília'],
  [/\bgoi[?]{1,6}s\b/gi, 'goiás'],
  [/\bgoi[?]{1,6}nia\b/gi, 'goiânia'],
  [/\bcear[?]{1,6}\b/gi, 'ceará'],
  [/\bpar[?]{1,6}\b/gi, 'pará'],
  [/\bpiau[?]{1,6}\b/gi, 'piauí'],
  [/\bamap[?]{1,6}\b/gi, 'amapá'],
  [/\brond[?]{1,6}nia\b/gi, 'rondônia'],
  [/\besp[?]{1,6}rito santo\b/gi, 'espírito santo'],
  [/\bant[?]{1,6}nio\b/gi, 'antônio'],
  [/\bs[?]{1,6}nia\b/gi, 'sônia'],
  [/\bol[?]{1,6}mpia\b/gi, 'olímpia'],
  [/\bem[?]{1,6}lia\b/gi, 'emília'],
  [/\bam[?]{1,6}rica\b/gi, 'américa'],
  [/\bc[?]{1,6}sar\b/gi, 'césar'],
  [/\bcanga[?]{1,6}ba\b/gi, 'cangaíba'],
  [/\bcarr[?]{1,6}o\b/gi, 'carrão'],
  [/\bbr[?]{1,6}s\b/gi, 'brás'],
  [/\bsanto andr[?]{1,6}\b/gi, 'santo andré'],
  [/\btatuap[?]{1,6}\b/gi, 'tatuapé'],
  [/\bjaguar[?]{1,6}\b/gi, 'jaguaré'],
  [/\btrememb[?]{1,6}\b/gi, 'tremembé'],
  [/\bbutant[?]{1,6}\b/gi, 'butantã'],
  [/\bsacom[?]{1,6}\b/gi, 'sacomã'],
  [/\bja[?]{1,6}an[?]{1,6}\b/gi, 'jaçanã'],
  [/\bja[?]{1,6}\b/gi, 'jaú'],
  [/\bgraja[?]{1,6}\b/gi, 'grajaú'],
  [/\bpacaemb[?]{1,6}\b/gi, 'pacaembu'],
  [/\bconcei[?]{1,6}o\b/gi, 'conceição'],
  [/\bconsola[?]{1,6}o\b/gi, 'consolação'],
  [/\bquadril[?]{1,6}tero\b/gi, 'quadrilátero'],

  // 3. Termos Financeiros, Contábeis e Documentos
  [/\bcart[?]{1,6}o\b/gi, 'cartão'],
  [/\bcart[?]{1,6}es\b/gi, 'cartões'],
  [/\bcr[?]{1,6}dito\b/gi, 'crédito'],
  [/\bcr[?]{1,6}ditos\b/gi, 'créditos'],
  [/\bd[?]{1,6}bito\b/gi, 'débito'],
  [/\bd[?]{1,6}bitos\b/gi, 'débitos'],
  [/\btransfer[?]{1,6}ncia\b/gi, 'transferência'],
  [/\btransfer[?]{1,6}ncias\b/gi, 'transferências'],
  [/\bbanc[?]{1,6}rio\b/gi, 'bancário'],
  [/\bbanc[?]{1,6}ria\b/gi, 'bancária'],
  [/\bbanc[?]{1,6}rios\b/gi, 'bancários'],
  [/\bbanc[?]{1,6}rias\b/gi, 'bancárias'],
  [/\bdep[?]{1,6}sito\b/gi, 'depósito'],
  [/\bdep[?]{1,6}sitos\b/gi, 'depósitos'],
  [/\bquita[?]{1,6}o\b/gi, 'quitação'],
  [/\bcobra[?]{1,6}a\b/gi, 'cobrança'],
  [/\bcobra[?]{1,6}as\b/gi, 'cobranças'],
  [/\bempr[?]{1,6}stimo\b/gi, 'empréstimo'],
  [/\bempr[?]{1,6}stimos\b/gi, 'empréstimos'],
  [/\bor[?]{1,6}amento\b/gi, 'orçamento'],
  [/\bor[?]{1,6}amentos\b/gi, 'orçamentos'],
  [/\bcomiss[?]{1,6}o\b/gi, 'comissão'],
  [/\bcomiss[?]{1,6}es\b/gi, 'comissões'],
  [/\bopera[?]{1,6}o\b/gi, 'operação'],
  [/\bopera[?]{1,6}es\b/gi, 'operações'],
  [/\btransa[?]{1,6}o\b/gi, 'transação'],
  [/\btransa[?]{1,6}es\b/gi, 'transações'],
  [/\bliquida[?]{1,6}o\b/gi, 'liquidação'],
  [/\bconcilia[?]{1,6}o\b/gi, 'conciliação'],
  [/\bantecipa[?]{1,6}o\b/gi, 'antecipação'],
  [/\btributa[?]{1,6}o\b/gi, 'tributação'],
  [/\brestitui[?]{1,6}o\b/gi, 'restituição'],
  [/\bhonor[?]{1,6}rio\b/gi, 'honorário'],
  [/\bhonor[?]{1,6}rios\b/gi, 'honorários'],
  [/\bsal[?]{1,6}rio\b/gi, 'salário'],
  [/\bsal[?]{1,6}rios\b/gi, 'salários'],
  [/\bcondom[?]{1,6}nio\b/gi, 'condomínio'],
  [/\bcondom[?]{1,6}nios\b/gi, 'condomínios'],
  [/\bpatrim[?]{1,6}nio\b/gi, 'patrimônio'],
  [/\bpatrim[?]{1,6}nios\b/gi, 'patrimônios'],
  [/\brelat[?]{1,6}rio\b/gi, 'relatório'],
  [/\brelat[?]{1,6}rios\b/gi, 'relatórios'],
  [/\bpre[?]{1,6}o\b/gi, 'preço'],
  [/\bpre[?]{1,6}os\b/gi, 'preços'],

  // 4. Termos Veiculares e Operacionais
  [/\bve[?]{1,6}culo\b/gi, 'veículo'],
  [/\bve[?]{1,6}culos\b/gi, 'veículos'],
  [/\bquil[?]{1,6}metro\b/gi, 'quilômetro'],
  [/\bquil[?]{1,6}metros\b/gi, 'quilômetros'],
  [/\bped[?]{1,6}gio\b/gi, 'pedágio'],
  [/\bped[?]{1,6}gios\b/gi, 'pedágios'],
  [/\bcombust[?]{1,6}vel\b/gi, 'combustível'],
  [/\bcombust[?]{1,6}veis\b/gi, 'combustíveis'],
  [/\bmanuten[?]{1,6}o\b/gi, 'manutenção'],
  [/\bmanuten[?]{1,6}es\b/gi, 'manutenções'],
  [/\blocat[?]{1,6}rio\b/gi, 'locatário'],
  [/\blocat[?]{1,6}ria\b/gi, 'locatária'],
  [/\bloca[?]{1,6}o\b/gi, 'locação'],
  [/\bloca[?]{1,6}es\b/gi, 'locações'],
  [/\bmedi[?]{1,6}o\b/gi, 'medição'],
  [/\bmedi[?]{1,6}es\b/gi, 'medições'],
  [/\bpresta[?]{1,6}o\b/gi, 'prestação'],
  [/\bpresta[?]{1,6}es\b/gi, 'prestações'],
  [/\bdi[?]{1,6}ria\b/gi, 'diária'],
  [/\bdi[?]{1,6}rio\b/gi, 'diário'],
  [/\bdi[?]{1,6}rias\b/gi, 'diárias'],
  [/\bhor[?]{1,6}rio\b/gi, 'horário'],
  [/\bhor[?]{1,6}rios\b/gi, 'horários'],
  [/\bsa[?]{1,6}da\b/gi, 'saída'],
  [/\bsa[?]{1,6}das\b/gi, 'saídas'],
  [/\bsa[?]{1,6}de\b/gi, 'saúde'],
  [/\bba[?]{1,6}\b/gi, 'baú'],
  [/\bba[?]{1,6}s\b/gi, 'baús'],
  [/\bmatr[?]{1,6}cula\b/gi, 'matrícula'],
  [/\busu[?]{1,6}rio\b/gi, 'usuário'],
  [/\busu[?]{1,6}rios\b/gi, 'usuários'],
  [/\bpropriet[?]{1,6}rio\b/gi, 'proprietário'],
  [/\bpropriet[?]{1,6}ria\b/gi, 'proprietária'],
  [/\bimobili[?]{1,6}ria\b/gi, 'imobiliária'],
  [/\bimobili[?]{1,6}rio\b/gi, 'imobiliário'],
  [/\bnoturna\?/gi, 'noturna'],
  [/\bnoturno\?/gi, 'noturno'],
  [/\bdiurna\?/gi, 'diurna'],
  [/\bdiurno\?/gi, 'diurno'],

  // 5. Termos Gerais de Sistema, Status e Ações
  [/\balimenta[?]{1,6}o\b/gi, 'alimentação'],
  [/\bgratifica[?]{1,6}o\b/gi, 'gratificação'],
  [/\bcomunica[?]{1,6}o\b/gi, 'comunicação'],
  [/\bnotifica[?]{1,6}o\b/gi, 'notificação'],
  [/\bnotifica[?]{1,6}es\b/gi, 'notificações'],
  [/\bautentica[?]{1,6}o\b/gi, 'autenticação'],
  [/\bautoriza[?]{1,6}o\b/gi, 'autorização'],
  [/\bautoriza[?]{1,6}es\b/gi, 'autorizações'],
  [/\baprova[?]{1,6}o\b/gi, 'aprovação'],
  [/\bsolicita[?]{1,6}o\b/gi, 'solicitação'],
  [/\bsolicita[?]{1,6}es\b/gi, 'solicitações'],
  [/\bavalia[?]{1,6}o\b/gi, 'avaliação'],
  [/\bavalia[?]{1,6}es\b/gi, 'avaliações'],
  [/\bvalida[?]{1,6}o\b/gi, 'validação'],
  [/\binscri[?]{1,6}o\b/gi, 'inscrição'],
  [/\binscri[?]{1,6}es\b/gi, 'inscrições'],
  [/\bdescri[?]{1,6}o\b/gi, 'descrição'],
  [/\bdescri[?]{1,6}es\b/gi, 'descrições'],
  [/\bobserva[?]{1,6}o\b/gi, 'observação'],
  [/\bobserva[?]{1,6}es\b/gi, 'observações'],
  [/\binstru[?]{1,6}o\b/gi, 'instrução'],
  [/\binstru[?]{1,6}es\b/gi, 'instruções'],
  [/\bconclus[?]{1,6}o\b/gi, 'conclusão'],
  [/\brescis[?]{1,6}o\b/gi, 'rescisão'],
  [/\brescis[?]{1,6}es\b/gi, 'rescisões'],
  [/\bsubstitui[?]{1,6}o\b/gi, 'substituição'],
  [/\bidentifica[?]{1,6}o\b/gi, 'identificação'],
  [/\bclassifica[?]{1,6}o\b/gi, 'classificação'],
  [/\bconfigura[?]{1,6}o\b/gi, 'configuração'],
  [/\bconfigura[?]{1,6}es\b/gi, 'configurações'],
  [/\bdecis[?]{1,6}o\b/gi, 'decisão'],
  [/\bexclus[?]{1,6}o\b/gi, 'exclusão'],
  [/\baltera[?]{1,6}o\b/gi, 'alteração'],
  [/\baltera[?]{1,6}es\b/gi, 'alterações'],
  [/\bmovimenta[?]{1,6}o\b/gi, 'movimentação'],
  [/\bmovimenta[?]{1,6}es\b/gi, 'movimentações'],
  [/\bprograma[?]{1,6}o\b/gi, 'programação'],
  [/\bprograma[?]{1,6}es\b/gi, 'programações'],
  [/\bexecu[?]{1,6}o\b/gi, 'execução'],
  [/\blibera[?]{1,6}o\b/gi, 'liberação'],
  [/\breten[?]{1,6}o\b/gi, 'retenção'],
  [/\baten[?]{1,6}o\b/gi, 'atenção'],
  [/\bsolu[?]{1,6}o\b/gi, 'solução'],
  [/\bsolu[?]{1,6}es\b/gi, 'soluções'],
  [/\bop[?]{1,6}o\b/gi, 'opção'],
  [/\bop[?]{1,6}es\b/gi, 'opções'],
  [/\bprodu[?]{1,6}o\b/gi, 'produção'],
  [/\bprodu[?]{1,6}es\b/gi, 'produções'],
  [/\bprote[?]{1,6}o\b/gi, 'proteção'],
  [/\binspe[?]{1,6}o\b/gi, 'inspeção'],
  [/\bsele[?]{1,6}o\b/gi, 'seleção'],
  [/\bred[?]{1,6}o\b/gi, 'redução'],
  [/\bcondu[?]{1,6}o\b/gi, 'condução'],
  [/\bdistribui[?]{1,6}o\b/gi, 'distribuição'],
  [/\bdoa[?]{1,6}o\b/gi, 'doação'],
  [/\bdoa[?]{1,6}es\b/gi, 'doações'],
  [/\bavan[?]{1,6}ado\b/gi, 'avançado'],
  [/\bavan[?]{1,6}ada\b/gi, 'avançada'],
  [/\bcome[?]{1,6}o\b/gi, 'começo'],
  [/\bcome[?]{1,6}ar\b/gi, 'começar'],
  [/\balmo[?]{1,6}o\b/gi, 'almoço'],
  [/\bpresen[?]{1,6}a\b/gi, 'presença'],
  [/\bmudan[?]{1,6}a\b/gi, 'mudança'],
  [/\bseguran[?]{1,6}a\b/gi, 'segurança'],
  [/\blicen[?]{1,6}a\b/gi, 'licença'],

  // 6. Palavras Gramaticais e Comuns
  [/\b[?]{1,6} vista\b/gi, 'à vista'],
  [/\bn[?]{1,6}mero\b/gi, 'número'],
  [/\bn[?]{1,6}meros\b/gi, 'números'],
  [/\bn[?]{1,6}\b/gi, 'Nº'],
  [/\bn[?]{1,6}o\b/gi, 'não'],
  [/\bent[?]{1,6}o\b/gi, 'então'],
  [/\btamb[?]{1,6}m\b/gi, 'também'],
  [/\bal[?]{1,6}m\b/gi, 'além'],
  [/\bpor[?]{1,6}m\b/gi, 'porém'],
  [/\bningu[?]{1,6}m\b/gi, 'ninguém'],
  [/\balgu[?]{1,6}m\b/gi, 'alguém'],
  [/\barmaz[?]{1,6}m\b/gi, 'armazém'],
  [/\bbel[?]{1,6}m\b/gi, 'belém'],
  [/\bpr[?]{1,6}prio\b/gi, 'próprio'],
  [/\bpr[?]{1,6}pria\b/gi, 'própria'],
  [/\bpr[?]{1,6}prios\b/gi, 'próprios'],
  [/\bpr[?]{1,6}prias\b/gi, 'próprias'],
  [/\bmat[?]{1,6}ria\b/gi, 'matéria'],
  [/\bmat[?]{1,6}rias\b/gi, 'matérias'],
  [/\bpol[?]{1,6}tica\b/gi, 'política'],
  [/\bpol[?]{1,6}ticas\b/gi, 'políticas'],
  [/\bger[?]{1,6}ncia\b/gi, 'gerência'],
  [/\bf[?]{1,6}sico\b/gi, 'físico'],
  [/\bf[?]{1,6}sica\b/gi, 'física'],
  [/\bjur[?]{1,6}dico\b/gi, 'jurídico'],
  [/\bjur[?]{1,6}dica\b/gi, 'jurídica'],
  [/\bpadr[?]{1,6}o\b/gi, 'padrão'],
  [/\bpadr[?]{1,6}es\b/gi, 'padrões'],
  [/\bm[?]{1,6}dico\b/gi, 'médico'],
  [/\bm[?]{1,6}dicos\b/gi, 'médicos'],
  [/\bv[?]{1,6}lido\b/gi, 'válido'],
  [/\binv[?]{1,6}lido\b/gi, 'inválido'],
  [/\bp[?]{1,6}s-pago\b/gi, 'pós-pago'],
  [/\bpr[?]{1,6}-pago\b/gi, 'pré-pago'],
  [/\batualiza[?]{1,6}o\b/gi, 'atualização'],
  [/\batualiza[?]{1,6}es\b/gi, 'atualizações'],
  [/\bconclu[?]{1,6}do\b/gi, 'concluído'],
  [/\bconclu[?]{1,6}da\b/gi, 'concluída'],
  [/\bconstru[?]{1,6}do\b/gi, 'construído'],
  [/\bdispon[?]{1,6}vel\b/gi, 'disponível'],
  [/\bindispon[?]{1,6}vel\b/gi, 'indisponível'],
  [/\bposs[?]{1,6}vel\b/gi, 'possível'],
  [/\bimposs[?]{1,6}vel\b/gi, 'impossível'],
  [/\brespons[?]{1,6}vel\b/gi, 'responsável'],
  [/\bvari[?]{1,6}vel\b/gi, 'variável'],
  [/\bcont[?]{1,6}bil\b/gi, 'contábil'],
  [/\bf[?]{1,6}cil\b/gi, 'fácil'],
  [/\bdif[?]{1,6}cil\b/gi, 'difícil'],
  [/\bpr[?]{1,6}ximo\b/gi, 'próximo'],
  [/\bpr[?]{1,6}xima\b/gi, 'próxima'],
  [/\bm[?]{1,6}ximo\b/gi, 'máximo'],
  [/\bm[?]{1,6}xima\b/gi, 'máxima'],
  [/\bm[?]{1,6}nimo\b/gi, 'mínimo'],
  [/\bm[?]{1,6}nima\b/gi, 'mínima'],
  [/\bc[?]{1,6}digo\b/gi, 'código'],
  [/\bc[?]{1,6}digos\b/gi, 'códigos'],
  [/\b[?]{1,6}timo\b/gi, 'ótimo'],
  [/\b[?]{1,6}tima\b/gi, 'ótima'],
  [/\bp[?]{1,6}ssimo\b/gi, 'péssimo'],
  [/\bp[?]{1,6}ssima\b/gi, 'péssima'],
  [/\bd[?]{1,6}vida\b/gi, 'dúvida'],
  [/\bd[?]{1,6}vidas\b/gi, 'dúvidas'],
  [/\bp[?]{1,6}gina\b/gi, 'página'],
  [/\bp[?]{1,6}ginas\b/gi, 'páginas'],
  [/\bvers[?]{1,6}o\b/gi, 'versão'],
  [/\bvers[?]{1,6}es\b/gi, 'versões'],
  [/\braz[?]{1,6}o\b/gi, 'razão'],
  [/\bfun[?]{1,6}o\b/gi, 'função'],
  [/\bfun[?]{1,6}es\b/gi, 'funções'],
  [/\bpermiss[?]{1,6}o\b/gi, 'permissão'],
  [/\bpermiss[?]{1,6}es\b/gi, 'permissões'],
  [/\bin[?]{1,6}cio\b/gi, 'início'],
  [/\bm[?]{1,6}s\b/gi, 'mês'],
  [/\batrav[?]{1,6}s\b/gi, 'através'],
  [/\bap[?]{1,6}s\b/gi, 'após'],
  [/\bat[?]{1,6}(?=\s|\d|[.,;:()\-–/]|$)/gi, 'até'],
  [/\brestri[?]{1,6}ao\b/gi, 'restrição'],
  [/\brestri[?]{1,6}o\b/gi, 'restrição'],
  [/\brestri[?]{1,6}es\b/gi, 'restrições'],
  [/\bjundia[?]{1,6}(?=\s|[.,;:()\-–/]|$)/gi, 'jundiaí'],
  [/\bmau[?]{1,6}(?=\s|[.,;:()\-–/]|$)/gi, 'mauá'],
  [/\bsumar[?]{1,6}(?=\s|[.,;:()\-–/]|$)/gi, 'sumaré'],
  [/\bba[?]{1,6}(?=\s|[.,;:()\-–/]|$)/gi, 'baú'],
  [/\b[?]{1,6}s\b/gi, 'às'],
  [/descarga[?]{1,6}diurna\b/gi, 'descarga diurna'],
  [/descarga[?]{1,6}noturna\b/gi, 'descarga noturna'],
  [/descarga[?]{1,6}diurno\b/gi, 'descarga diurno'],
  [/descarga[?]{1,6}noturno\b/gi, 'descarga noturno'],
  [/1\.500[?]{1,6}kg/gi, '1.500 KG'],
  [/\bj[?]{1,6}(?=\s|[.,;:()\-–/]|$)/gi, 'já'],
  [/\best[?]{1,6}(?=\s|[.,;:()\-–/]|$)/gi, 'está'],
  [/\best[?]{1,6}o\b/gi, 'estão'],
  [/\bser[?]{1,6}(?=\s|[.,;:()\-–/]|$)/gi, 'será'],
  [/\bser[?]{1,6}o\b/gi, 'serão'],
  [/\bvoc[?]{1,6}(?=\s|[.,;:()\-–/]|$)/gi, 'você'],
  [/\bvoc[?]{1,6}s\b/gi, 'vocês']
];

// Mojibake direto (dupla codificação UTF-8 sobre ISO-8859-1/Windows-1252)
const MOJIBAKE_MAP: Record<string, string> = {
  'Ã¡': 'á', 'Ã ': 'à', 'Ã£': 'ã', 'Ã¢': 'â',
  'Ã©': 'é', 'Ã¨': 'è', 'Ãª': 'ê',
  'Ã­': 'í', 'Ã¬': 'ì', 'Ã®': 'î',
  'Ã³': 'ó', 'Ã²': 'ò', 'Ãµ': 'õ', 'Ã´': 'ô',
  'Ãº': 'ú', 'Ã¹': 'ù', 'Ã»': 'û', 'Ã¼': 'ü',
  'Ã§': 'ç',
  'Ã\x81': 'Á', 'Ã\x80': 'À', 'Ã\x83': 'Ã', 'Ã\x82': 'Â',
  'Ã\x89': 'É', 'Ã\x88': 'È', 'Ã\x8a': 'Ê',
  'Ã\x8d': 'Í', 'Ã\x8c': 'Ì', 'Ã\x8e': 'Î',
  'Ã\x93': 'Ó', 'Ã\x92': 'Ò', 'Ã\x95': 'Õ', 'Ã\x94': 'Ô',
  'Ã\x9a': 'Ú', 'Ã\x99': 'Ù', 'Ã\x9b': 'Û', 'Ã\x9c': 'Ü',
  'Ã\x87': 'Ç',
  'Â°': '°', 'Âª': 'ª', 'Âº': 'º', 'Â§': '§',
  'Ã\x82Â': ''
};

/**
 * Corrige uma palavra individual ou texto aplicando regras de dicionário e padrões morfológicos
 */
function applySmartRepair(input: string): string {
  let text = input;

  // 1. Correção de Mojibake
  for (const [bad, good] of Object.entries(MOJIBAKE_MAP)) {
    if (text.includes(bad)) {
      text = text.split(bad).join(good);
    }
  }

  // 2. Dicionário de termos conhecidos
  for (const [regex, replacement] of EXACT_REPLACEMENTS) {
    text = text.replace(regex, (match) => {
      // Preservar capitalização original (tudo maiúsculo ou primeira letra maiúscula)
      if (match === match.toUpperCase()) {
        return replacement.toUpperCase();
      }
      if (match[0] === match[0].toUpperCase()) {
        return replacement.charAt(0).toUpperCase() + replacement.slice(1);
      }
      return replacement;
    });
  }

  // 3. Padrões morfológicos gerais para interrogações residuais
  // Palavras com sufixo [?]o ou [?]ao -> ão ou ção
  text = text.replace(/([a-zA-Z])[?]{1,6}(o|ao)\b/gi, (match, prefix) => {
    const p = prefix.toLowerCase();
    if (['a', 'e', 'i', 'u', 'r', 'n', 'c'].includes(p)) {
      return prefix === prefix.toUpperCase() ? `${prefix}ÇÃO` : `${prefix}ção`;
    }
    return prefix === prefix.toUpperCase() ? `${prefix}ÃO` : `${prefix}ão`;
  });

  // Sufixo [?]es -> ções
  text = text.replace(/([a-zA-Z])[?]{1,6}es\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÇÕES` : `${prefix}ções`;
  });

  // Sufixo [?]vel -> ível
  text = text.replace(/([a-zA-Z])[?]{1,6}vel\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÍVEL` : `${prefix}ível`;
  });

  // Sufixo [?]rio / [?]ria -> ário / ária
  text = text.replace(/([a-zA-Z])[?]{1,6}rio\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÁRIO` : `${prefix}ário`;
  });
  text = text.replace(/([a-zA-Z])[?]{1,6}ria\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÁRIA` : `${prefix}ária`;
  });

  // Sufixo [?]ncia -> ência
  text = text.replace(/([a-zA-Z])[?]{1,6}ncia\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÊNCIA` : `${prefix}ência`;
  });

  // Sufixo [?]tico / [?]tica -> ático / ática
  text = text.replace(/([a-zA-Z])[?]{1,6}tica\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÁTICA` : `${prefix}ática`;
  });
  text = text.replace(/([a-zA-Z])[?]{1,6}tico\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÁTICO` : `${prefix}ático`;
  });

  // Sufixo [?]mico / [?]mica -> âmico / âmica
  text = text.replace(/([a-zA-Z])[?]{1,6}mica\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÂMICA` : `${prefix}âmica`;
  });
  text = text.replace(/([a-zA-Z])[?]{1,6}mico\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÂMICO` : `${prefix}âmico`;
  });

  // Sufixo [?]nico / [?]nica -> ânico / ânica
  text = text.replace(/([a-zA-Z])[?]{1,6}nica\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÂNICA` : `${prefix}ânica`;
  });
  text = text.replace(/([a-zA-Z])[?]{1,6}nico\b/gi, (match, prefix) => {
    return prefix === prefix.toUpperCase() ? `${prefix}ÂNICO` : `${prefix}ânico`;
  });

  // Limpeza de resíduos de ?? perdidos no meio de palavras (ex: cer??mica restante)
  text = text.replace(/([a-zA-ZÀ-ÿ])[?]{1,6}([a-zA-ZÀ-ÿ])/gi, '$1$2');

  // Limpeza de interrogações múltiplas residuais
  text = text.replace(/[?]{2,}/g, '');

  return text;
}

/**
 * Sanitiza um texto em string, corrigindo '??', '???' e codificação corrompida.
 */
export function sanitizeText(text?: string | null): string {
  if (!text) return '';
  if (typeof text !== 'string') return String(text);
  if (!text.includes('?') && !text.includes('Ã') && !text.includes('Â')) {
    return text;
  }
  return applySmartRepair(text);
}

/**
 * Sanitização profunda e recursiva de qualquer objeto, array ou string
 */
export function sanitizeDeep<T>(val: T): T {
  if (val === null || val === undefined) return val;
  if (typeof val === 'string') return sanitizeText(val) as any;
  if (Array.isArray(val)) {
    return val.map((item) => sanitizeDeep(item)) as any;
  }
  if (typeof val === 'object' && !(val instanceof Date)) {
    const res: any = {};
    for (const key of Object.keys(val)) {
      res[key] = sanitizeDeep((val as any)[key]);
    }
    return res;
  }
  return val;
}

/**
 * Sanitiza dados de uma Ordem de Serviço
 */
export function sanitizeOS<T>(os: T): T {
  if (!os) return os;
  return sanitizeDeep(os);
}

/**
 * Sanitiza dados de uma Pessoa / Motorista / Cliente
 */
export function sanitizePessoa<T>(pessoa: T): T {
  if (!pessoa) return pessoa;
  return sanitizeDeep(pessoa);
}

/**
 * Sanitiza dados de uma Conta do financeiro
 */
export function sanitizeConta<T>(conta: T): T {
  if (!conta) return conta;
  return sanitizeDeep(conta);
}

/**
 * Sanitiza entidade Categoria
 */
export function sanitizeCategoria<T extends { nome: string }>(categoria: T): T {
  if (!categoria) return categoria;
  return sanitizeDeep(categoria);
}

/**
 * Sanitiza entidade FormaPagamento
 */
export function sanitizeFormaPagamento<T extends { nome: string }>(forma: T): T {
  if (!forma) return forma;
  return sanitizeDeep(forma);
}

/**
 * Sanitiza entidade Banco
 */
export function sanitizeBanco<T extends { nome?: string | null }>(banco: T): T {
  if (!banco) return banco;
  return sanitizeDeep(banco);
}

/**
 * Sanitiza entidade TipoConta
 */
export function sanitizeTipoConta<T extends { nome: string }>(tipo: T): T {
  if (!tipo) return tipo;
  return sanitizeDeep(tipo);
}

/**
 * Sanitiza entidade Cobranca
 */
export function sanitizeCobranca<T>(cobranca: T): T {
  if (!cobranca) return cobranca;
  return sanitizeDeep(cobranca);
}
